var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClip18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 12c0 .495-.101 1-.101 1a5 5 0 0 1-9.798 0S4 12.565 4 12V4a3 3 0 1 1 6 0v8a1 1 0 0 1-2 0V4a1 1 0 0 0-2 0s-.01 7.485 0 8c.01.515.164 1 .164 1A3.01 3.01 0 0 0 9 15.019c.658 0 1.263-.212 1.756-.57A3.046 3.046 0 0 0 11.836 13s.155-.485.164-1V7a1 1 0 0 1 2 0v5z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE0IDEyYzAgLjQ5NS0uMTAxIDEtLjEwMSAxYTUgNSAwIDAgMS05Ljc5OCAwUzQgMTIuNTY1IDQgMTJWNGEzIDMgMCAxIDEgNiAwdjhhMSAxIDAgMCAxLTIgMFY0YTEgMSAwIDAgMC0yIDBzLS4wMSA3LjQ4NSAwIDhjLjAxLjUxNS4xNjQgMSAuMTY0IDFBMy4wMSAzLjAxIDAgMCAwIDkgMTUuMDE5Yy42NTggMCAxLjI2My0uMjEyIDEuNzU2LS41N0EzLjA0NiAzLjA0NiAwIDAgMCAxMS44MzYgMTNzLjE1NS0uNDg1LjE2NC0xVjdhMSAxIDAgMCAxIDIgMHY1eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export { SvgClip18 as ReactComponent };